import React from 'react';
import { URL } from '../variables';
import { languages, languageOptions, getSelectedLanguage, setSelectedLanguage } from '../languages';
import Loader from '../components/Loader';

class SelectFaculdade extends React.Component {
  constructor(props) {
    super(props);
    this.state = { faculdades: [], faculdade_select: 'tete', loading: false, msgErro: '', redirect: false, theme: localStorage.getItem('avaliador_theme') || 'light', selectedLanguage: getSelectedLanguage() }
  }

  change_faculdade(event) { this.setState({ faculdade_select: event.target.value }); }

  get_faculdades() {
    fetch(`${URL}api/avaliador/get_faculdades`, { method: 'GET', headers: { Accept: 'application/json' } }).then(async (responseLog) => {
      try {
        let resp = await responseLog.json();
        if (resp.errors != null || resp.error != null) {
          let errors = Object.values(resp.errors); let erro = '';
          for (let i = 0; i < errors.length; i++) erro += errors[i] + (i != errors.length - 1 ? '\n' : '');
          this.setState({ loading: false, msgErro: erro, refresh: false, loadingMore: false });
        }
        else {
          let selected = resp.faculdades.length > 0 ? resp.faculdades[0].slug : '';
          this.setState({ faculdades: resp.faculdades, loading: false, msgErro: '', faculdade_select: selected });
        }
      } catch (err) {
        console.log(err); this.setState({ loading: false, msgErro: 'Erro ao pegar resposta do servidor', refresh: false, loadingMore: false });
      }
    }).catch((err) => {
      console.log(err); this.setState({ loading: false, msgErro: 'Erro ao pegar resposta do servidor. Você está conectado a internet?', refresh: false, loadingMore: false });
    });
  }

  componentDidMount() {
    document.body.classList.toggle('avaliador-dark-theme', this.state.theme == 'dark');
    this.languageListener = () => this.setState({ selectedLanguage: getSelectedLanguage() });
    window.addEventListener('avaliador_language_change', this.languageListener);
    this.setState({ loading: true, msgErro: '' });
    this.get_faculdades();
  }

  componentWillUnmount() { if (this.languageListener) window.removeEventListener('avaliador_language_change', this.languageListener); }

  toggleTheme() {
    let theme = this.state.theme == 'dark' ? 'light' : 'dark';
    localStorage.setItem('avaliador_theme', theme);
    document.body.classList.toggle('avaliador-dark-theme', theme == 'dark');
    this.setState({ theme });
  }

  changeLanguage(event) {
    let selectedLanguage = setSelectedLanguage(event.target.value);
    this.setState({ selectedLanguage });
  }

  render() {
    let t = languages[this.state.selectedLanguage] || languages.Pt;
    return (
      <div>
        {this.state.loading && <Loader fullScreen title={t.loading_data} description={t.loading_environment} />}
        {this.state.loading == false && <div className="avaliador-select-page">
          <header className="avaliador-select-header">
            <a className="logo"><img src={require('../assets/images/logo-ontest.png')} height="58" alt="logo" /></a>
            <div className="avaliador-select-controls">
              <button type="button" className="avaliador-preference-theme-button compact" onClick={this.toggleTheme.bind(this)} title={this.state.theme == 'dark' ? t.theme_light : t.theme_dark}>
                <i className={this.state.theme == 'dark' ? 'mdi mdi-white-balance-sunny' : 'mdi mdi-weather-night'}></i>
                <span>{this.state.theme == 'dark' ? t.theme_light : t.theme_dark}</span>
              </button>
              <label className="avaliador-preference-select compact">
                <i className="mdi mdi-web"></i>
                <select value={this.state.selectedLanguage} onChange={this.changeLanguage.bind(this)} aria-label={t.language_label} title={t.language_label}>{languageOptions.map((item) => <option key={item.value} value={item.value}>{item.value}</option>)}</select>
              </label>
            </div>
          </header>
          <main className="avaliador-select-main">
            <section className="avaliador-select-card">
              <div className="avaliador-select-copy"><span>{t.evaluator_panel}</span><h1>{t.select_institution_title}</h1><p>{t.select_institution_subtitle}</p></div>
              <div className="avaliador-select-list">
                {this.state.faculdades.map((item, id) => (
                  <a key={id} href={'/' + item.slug + '/login'} className="avaliador-select-item">
                    <div className="avaliador-select-logo"><img src={item.logo} alt="logo" /></div>
                    <div className="avaliador-select-info"><strong>{item.name}</strong><span>{t.access_workspace}</span></div>
                    <div className="avaliador-select-action">{t.access} <i className="mdi mdi-arrow-right"></i></div>
                  </a>
                ))}
                {this.state.faculdades.length == 0 && <div className="avaliador-select-empty"><i className="mdi mdi-school-outline"></i><p>{t.no_institution_available}</p></div>}
              </div>
            </section>
          </main>
        </div>}
      </div>
    );
  }
}
export default SelectFaculdade;
